<template>
  <div>
    <div class="contribute">
      <div class="inner_view">
        <div>
          <span style="line-height: 32px">项目名称:</span>
          <el-input
            v-model="select.selectWork"
            @clear="getApplyList"
            placeholder="请输入项目名称"
            :clearable="true"
            style="margin-left: 10px;width: 150px;margin-right: 20px;"
          ></el-input>
        </div>
        <div>
          <span style="line-height: 32px;">申报人:</span>
          <el-input
            v-model="select.selectName"
            @clear="getApplyList"
            placeholder="请输入申报人"
            :clearable="true"
            style="margin-left: 10px;width: 150px;margin-right: 20px;"
          ></el-input>
        </div>
        <div>
          <span style="line-height: 32px;">项目类型:</span>
          <el-select
            v-model="select.selectValue1"
            @clear="getApplyList"
            clearable
            placeholder="请选择"
            style="width: auto;margin-left: 10px;margin-right: 20px;"
          >
            <el-option
              v-for="(item, index) in select.options1"
              :key="index"
              :label="item.text"
              :value="index"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <span style="line-height: 32px;">审核状态:</span>
          <el-select
            v-model="select.selectValue2"
            @clear="getApplyList"
            clearable
            placeholder="请选择"
            style="width: 150px;margin-left: 10px;margin-right: 20px;"
          >
            <el-option
              v-for="(item, index) in select.options2"
              :key="index"
              :label="item.text"
              :value="index"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <span style="line-height: 32px;">提交时间:</span>
          <el-date-picker
            v-model="select.selectValue3"
            @change="getApplyList"
            value-format="yyyy-MM-dd"
            style="width: 240px;margin-left: 10px;margin-right: 20px;"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

        <el-button type="primary" @click="searchData">
          查询
        </el-button>
      </div>
      <!-- 我要投稿 -->
      <!-- 批量同意推荐 -->
      <el-button type="primary" @click="setRecommend">同意推荐</el-button>
    </div>

    <div class="infoBody">
      <!-- 特俗样式表格 -->
      <normalTable
        v-loading="loading"
        :check="true"
        :tabList="tabList"
        :tableList="tableList"
        @copol-click="reciveClick"
        @checkbox="checkBox"
      ></normalTable>
    </div>
    <div style="margin-top: 50px;" v-if="totalNum > 10">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
      >
      </el-pagination>
    </div>

    <!-- 弹窗 -->
    <scoreDialog ref="scoredialog" @chooseDetail="chooseDetail"></scoreDialog>

    <!-- 消息弹窗 -->
    <setTimeDialog ref="settimedialog"></setTimeDialog>

    <givePointDialog ref="givePoint"></givePointDialog>
  </div>
</template>

<script>
import {
  getApplyList,
  givePoint,
  setRecommend,
} from "../../api/moudles/management.js";
import { getProjectType } from "../../api/moudles/application.js";
import normalTable from "../../components/table/normalTable.vue";
import scoreDialog from "./components/scoreDialog.vue";
import setTimeDialog from "./components/setTimeDialog.vue";
import givePointDialog from "./components/givePoint.vue";
export default {
  data() {
    return {
      project_type: [],
      select: {
        options1: [],
        options2: [],
        selectWork: "",
        selectName: "",
        selectValue1: "",
        selectValue2: "",
        selectValue3: "",
      },
      loading: true,
      tabList: ["项目类型", "项目名称", "申报人", "提交时间", "状态", "动作"],
      tableList: [],
      tabCodeList: [],
      ids: [],
      // 分页
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
    };
  },
  computed: {},
  components: {
    normalTable,
    scoreDialog,
    setTimeDialog,
    givePointDialog,
  },
  created() {
    this.getApplyList();
    this.getProjecttype();
  },
  methods: {
    // 获取下拉选项
    async getProjecttype() {
      await getProjectType({
        data: {},
        success: (res) => {
          const typeAll = res.data.typeAll;
          const appStatus = res.data.appStatus;
          const newtypeAll = [];
          const newAppStatus = [];
          Object.keys(typeAll).forEach((item, index) => {
            const newList = {};
            newList.text = typeAll[item];
            newtypeAll.push(newList);
          });
          appStatus.forEach((item, index) => {
            const newList = {};
            newList.text = item;
            newAppStatus.push(newList);
          });
          this.select.options1 = newtypeAll;
          this.select.options2 = newAppStatus;
        },
      });
    },
    searchData() {
      this.getApplyList();
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getApplyList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getApplyList();
    },
    // 接口一：获取项目列表
    async getApplyList() {
      this.loading = true;
      await getApplyList({
        data: {
          apply_by: this.select.selectName,
          project_name: this.select.selectWork,
          project_type: this.select.selectValue1,
          app_status: this.select.selectValue2,
          apply_time: this.select.selectValue3,
          page: this.currentPage,
          limit: this.pageSize,
        },
        success: (res) => {
          this.totalNum = res.totalCount;
          // console.log(res.data)
          let dataList = res.data;
          // code列表
          let upCode = [];
          let upList = [];
          // 类型列表
          let project_type = [];

          dataList.forEach((item) => {
            let newlist = {};
            newlist["project_type_name"] = item.project.project_type_name;
            newlist["project_name"] = item.project.project_name;
            newlist["created_by"] = item.created_by;
            newlist["created_at"] = item.created_at;
            newlist["statusText"] = item.statusText;
            if (item.statusText === "已提交") {
              newlist["soqcol"] = ["同意推荐", "查看"];
            } else if (
              item.statusText === "已推荐" &&
              item.project.project_type == 4
            ) {
              newlist["soqcol"] = ["初审打分", "查看"];
            } else {
              newlist["soqcol"] = ["查看"];
            }
            upCode.push(item.id);
            project_type.push(item.project.project_type);
            upList.push(newlist);
          });
          this.tabCodeList = upCode;
          this.tableList = upList;
          this.project_type = project_type;
          this.loading = false;
        },
      });
    },
    // 接口二：评分
    async givePoint() {
      await givePoint({
        data: {
          id: "",
          point: "",
        },
        success: (res) => {
          console.log(res);
        },
      });
    },
    // 接口三：批量推荐
    async setRecommend() {
      if (!this.ids.length) {
        this.$message.error("请先选中数据");
        return;
      }
      const params = {
        ids: this.ids,
      };
      await setRecommend({
        data: {
          ids: this.ids,
        },
        success: (res) => {
          if (res.code === 200) {
            this.$refs["settimedialog"].showAdd("success", res);
          } else {
            this.$refs["settimedialog"].showAdd("fail", res);
          }
          this.getApplyList();
        },
      });
    },
    // 接受子组件事件
    chooseDetail(e) {
      if (e.type) {
        this.$refs["settimedialog"].showAdd("success", e.res);
      } else {
        this.$refs["settimedialog"].showAdd("fail", e.res);
      }
      this.getApplyList();
    },
    // 复选框
    checkBox(e) {
      // console.log('接收到复选框', e)
      const newList = [];
      e.forEach((item, index) => {
        if (item === true) {
          newList.push(this.tabCodeList[index]);
        }
      });
      this.ids = newList;
    },
    reciveClick(e) {
      const { list, key } = e;
      if (list === "初审打分") {
        const params = {
          ids: [this.tabCodeList[key]],
        };
        this.$refs["givePoint"].showAdd("初审打分", params);
      } else if (list === "同意推荐") {
        const params = {
          ids: [this.tabCodeList[key]],
        };
        this.$refs["scoredialog"].showAdd("同意推荐", params);
      } else if (list === "查看") {
        if (this.project_type[key] === "4") {
          this.$router.push({
            name: "newCreditEnterDetail",
            params: {
              id: this.tabCodeList[key],
            },
          });
        } else {
          this.$router.push({
            name: "newcontribute",
            params: {
              id: this.tabCodeList[key],
            },
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.contribute {
  display: flex;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 40px;
}

.inner_view {
  line-height: 50px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: flex-start;
}
/* 信息变更内容主体 */
.infoBody {
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}

.contribute_head {
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
}

.contribute_head button {
  width: 85px;
  height: 30px;
  background: #158aed;
  border-radius: 2px;
  cursor: pointer;
  color: #ffffff;
}
</style>
